import { Button, Modal, Flex } from '@sequencehq/core-components'
import { WebhookSecretDetails } from './WebhookSecretDetails'

/**
 * Confirmation modal shown immediately after a webhook is created so the user
 * can copy the signing secret without having to dig through the kebab menu
 * later. The secret is only returned on creation, so surfacing it here avoids
 * the "where did my secret go?" problem.
 */
export const WebhookCreatedModal = ({
  isOpen,
  webhookSecret,
  onClose
}: {
  isOpen: boolean
  webhookSecret?: string
  onClose: () => void
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header showCloseButton onClose={onClose} withBorder>
        Webhook created
      </Modal.Header>

      <Modal.Content minHeight="auto">
        <WebhookSecretDetails webhookSecret={webhookSecret} />
      </Modal.Content>

      <Modal.Footer withBorder>
        <Flex justifyContent="end" width="100%" alignItems="center" gap="8px">
          <Button
            variant="primary"
            onClick={onClose}
            data-testid="webhooks.createdModal.done"
          >
            Done
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  )
}
